import de from './de.json';
import en from './en.json';
import es from './es.json';
import no from './no.json';
import ru from './ru.json';
import pl from './pl.json';
import ro from './ro.json';
import pt from './pt.json';
import sv from './sv.json';
import th from './th.json';
import tr from './tr.json';
import zh_cn from './zh_cn.json';
import zh_tw from './zh_tw.json';
import { i18n } from 'locales';

i18n.addResourceBundle('de', 'x50', de, true);
i18n.addResourceBundle('en', 'x50', en, true);
i18n.addResourceBundle('es', 'x50', es, true);
i18n.addResourceBundle('no', 'x50', no, true);
i18n.addResourceBundle('ru', 'x50', ru, true);
i18n.addResourceBundle('pl', 'x50', pl, true);
i18n.addResourceBundle('ro', 'x50', ro, true);
i18n.addResourceBundle('pt', 'x50', pt, true);
i18n.addResourceBundle('sv', 'x50', sv, true);
i18n.addResourceBundle('th', 'x50', th, true);
i18n.addResourceBundle('tr', 'x50', tr, true);
i18n.addResourceBundle('zh_cn', 'x50', zh_cn, true);
i18n.addResourceBundle('zh_tw', 'x50', zh_tw, true);
